/**
 * 中台模块接口列表api
 */

import base from './base/index'; // 接口域名列表
import axios from '../utils/http'; // 导入http中创建的axios实例
import utils from "../utils";


const tmp = {
  /**
   * 获取信息概览
   * measureId//计量点id
   */
  getPowerQualityInfo (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getPowerQualityInfo, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 获取信息概览--实时曲线—线电压
   * measureId//计量点id
   */
  getPowerQualityInfoVoltageXY (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getPowerQualityInfoVoltageXY, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 信息概览--实时曲线—相电压
   * measureId//计量点id
   */
  getPowerQualityInfoVoltageX (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getPowerQualityInfoVoltageX, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 三相不平衡
   * measureId//计量点id
   */
  getThreePhaseUnbalance (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getThreePhaseUnbalance, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 获取电压不平衡度曲线
   * measureId//计量点id
   */
  getRealTimeVoltageUnbalance (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getRealTimeVoltageUnbalance, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 电流不平衡度曲线
   * measureId//计量点id
   */
  getRealTimeCurrentUnbalance (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getRealTimeCurrentUnbalance, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 基波电压有效值曲线
   * measureId//计量点id
   */
  getFundamentalVoltage (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getFundamentalVoltage, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 基波电流有效值曲线
   * measureId//计量点id
   */
  getFundamentalCurrent (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getFundamentalCurrent, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 获取运行状态
   * @param {*} measureId 
   */
  getRunningState (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getRunningState, utils.postParamsArrayToJsonString(params))
  },

  /**
   * 变压器概况
   * measureId//计量点id
   */
  getTransformersSummary () {
    let params = {
    }
    return axios.post(base.tmp.getTransformersSummary, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 运行状态
   * measureId//计量点id
   */
  getWholePlantRunningState () {
    let params = {
    }
    return axios.post(base.tmp.getWholePlantRunningState, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 外网温湿度
   * measureId//计量点id
   */
  getWSD () {
    let params = {
    }
    return axios.post(base.tmp.getWSD, utils.postParamsArrayToJsonString(params))
  },
  /**用电概况
   * 
   * measureId//计量点id
   */
  getWholePlantEnegeSumary (companyId, timeType, measureId, time) {
    let params = {
      companyId: companyId,
      timeType: timeType,
      measureId,
      time
    }
    return axios.post(base.tmp.getWholePlantEnegeSumary, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 5、电能使用情况
   * @param {*} measureId 
   * @param {*} startTime 
   * @param {*} endTime 
   */
  getPowerRunningState (measureId, startTime, endTime) {
    let params = {
      measureId: measureId, startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime, endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime
    }
    return axios.post(base.tmp.getPowerRunningState, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 6、流量使用情--水、蒸气
   * @param {*} measureId 
   * @param {*} startTime 
   * @param {*} endTime 
   */
  getFlowRunningState (measureId, startTime, endTime) {
    let params = {
      measureId: measureId, startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime, endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime
    }
    return axios.post(base.tmp.getFlowRunningState, utils.postParamsArrayToJsonString(params))

  },
  /**
   *地图导航
   * @param {*} companyId  公司id
   */
  getMapNavigation (companyId) {
    let params = {
      companyId: companyId
    }
    return axios.post(base.tmp.getMapNavigation, utils.postParamsArrayToJsonString(params))
  },
  /**
   *抄表统计
   * @param {*} measuresId  测量点id
   * @param {*} startTime  开始时间
   * @param {*} energyType  能源类型（电1、水2、气3）
   * @param {*} timeType  endTime:typeof(endTime)=='string'?endTime.replace(/-/g,'/'):endTime（1 日，2 月，3 年）
   * @param {*} queryType  查询类型（1用量2表码）
   */
  getEnergyStatistics (measuresId, startTime, energyType, timeType, queryType) {
    let params = {
      measuresId: JSON.stringify(measuresId), startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime, energyType: energyType, timeType: timeType, queryType: queryType
    }
    return axios.post(base.tmp.getEnergyStatistics, utils.postParamsArrayToJsonString(params))
  },


  /**
   *供电偏差  
   * @param {*} measureId  测量点id
   */
  getPowerDeviation (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getPowerDeviation, utils.postParamsArrayToJsonString(params))
  },
  /**
   *实时曲线-相电压偏差  
   * @param {*} measureId  测量点id
   */
  getPhaseVoltageDeviationRealTime (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getPhaseVoltageDeviationRealTime, utils.postParamsArrayToJsonString(params))
  },
  /**
   *实时曲线-线电压偏差  
   * @param {*} measureId  测量点id
   */
  getLineVoltageDeviationRealTime (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getLineVoltageDeviationRealTime, utils.postParamsArrayToJsonString(params))
  },
  /**
   *实时曲线-频率 
   * @param {*} measureId  测量点id
   */
  getFrequencyRealTime (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getFrequencyRealTime, utils.postParamsArrayToJsonString(params))
  },
  /**
   *实时曲线-频率偏差 
   * @param {*} measureId  测量点id
   */
  getFrequencyDeviationRealTime (measureId) {
    let params = {
      measureId: measureId
    }
    return axios.post(base.tmp.getFrequencyDeviationRealTime, utils.postParamsArrayToJsonString(params))
  },
  /**
   *谐波 
   * @param {*} measureId  测量点id
   * @param {*} harmonicType  谐波类型：1谐波含有率，2谐波有效值，3谐波功率
   * @param {*} loadType  负荷类型：1电压，2电流，3有功功率，4无功功率，5视在功率。谐波类型是谐波含有率或者谐波有效值时，负荷类型loadType：1电压，2电流。谐波类型是谐波功率时，负荷类型loadType：3有功功率，4无功功率，5视在功率。
   * @param {*} showOrderType  分次显示类型：1全部，2奇次，3偶次
   */
  getCurrentHarmonic (measureId, harmonicType, loadType, showOrderType) {
    let params = {
      measureId, harmonicType, loadType, showOrderType
    }
    return axios.post(base.tmp.getCurrentHarmonic, utils.postParamsArrayToJsonString(params))
  },
  /**
   *能耗分析趋势
   * @param {*} viewNodeId  测量点
   * @param {*} pointCode  '100229'
   * @param {*} pointNumber  '0
   * @param {*} startTime  开始时间
   * @param {*} endTime  结束时间
   * @param {*} dateType  时间类型
   */
  getLossAnalysis (viewNodeId, pointCode, pointNumber, startTime, endTime, dateType) {
    let params = {
      viewNodeId, pointCode, pointNumber,
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      dateType
    }
    return axios.post(base.tmp.getLossAnalysis, utils.postParamsArrayToJsonString(params))
  },

  // /tmp/getGroupDataInfo

  /**
   * 分类分组组合数据
   * @param {*} viewNodeId 视图节点id
   * @param {*} classFilter 参考开发档
   * @param {*} expressionName 采集公式名称
   * @param {*} IsRang 是否环比
   * @param {*} time 时间
   */
  getGroupDataInfo (viewNodeId, classFilter, expressionName, isRang, time) {
    let params = {
      viewNodeId, classFilter, expressionName, isRang, time
    }
    return axios.post(base.tmp.getGroupDataInfo, utils.postParamsArrayToJsonString(params))
  },
  getGroupDataInfo2 (measureId, classFilter, expressionName, isRang, time, container) {
    let params = {
      measureId, classFilter, expressionName, isRang, time, container
    }
    return axios.post(base.tmp.getGroupDataInfo2, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 工作日能耗分析
   * @param {*} measureStr 节点数据
   * @param {*} dateStr 时间数据
   * @param {*} type 时间类型
   */
  getEnergyAnalysisOfWorkingDay (measureStr, dateStr, type) {
    let params = {
      measureStr, dateStr, type
    }
    return axios.post(base.tmp.getEnergyAnalysisOfWorkingDay, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 上下班能耗分析
   * @param {*} measureStr 节点数据
   * @param {*} dateStr 时间数据
   * @param {*} type 时间类型
   */
  getEnergyAnalysisOfWorkingTime (measureStr, dateStr, type) {
    let params = {
      measureStr, dateStr, type
    }
    return axios.post(base.tmp.getEnergyAnalysisOfWorkingTime, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 人均单耗同环比
   * @param {*} measureId 侧量点
   * @param {*} pointCode 
   * @param {*} pointNumber 
   * @param {*} startTime 
   * @param {*} endTime 
   * @param {*} isRang 1是环比。0是同比 
   * @param {*} cycle 时间类型 hour day month 
   */
  getCapitaConsume (measureId, pointCode, pointNumber, startTime, endTime, isRang, cycle) {
    let params = {
      measureId, pointCode, pointNumber,
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      isRang, cycle
    }
    return axios.post(base.tmp.getCapitaConsume, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 面均单耗同环比
   * @param {*} measureId 侧量点
   * @param {*} pointCode 
   * @param {*} pointNumber 
   * @param {*} startTime 
   * @param {*} endTime 
   * @param {*} isRang 1是环比。0是同比 
   * @param {*} cycle 时间类型 hour day month 
   */
  getAreaConsume (measureId, pointCode, pointNumber, startTime, endTime, isRang, cycle) {
    let params = {
      measureId, pointCode, pointNumber,
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      isRang, cycle
    }
    return axios.post(base.tmp.getAreaConsume, utils.postParamsArrayToJsonString(params))
  },

  /**
   * 警报设备
   * @param {*} measureId 
   * @param {*} command 
   * @param {*} args 
   */
  executeCommandOnMeasure (measureId, command, args) {

    let params = {
      measureId, command, args
    }
    return axios.post(base.tmp.executeCommandOnMeasure, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 警报设备
   * @param {*} measureId 
   * @param {*} beforeStartTime   改造前开始时间
   * @param {*} beforeEndTime    改造前结束时间
   * @param {*} afterStartTime    改造后开始时间
   * @param {*} afterEndTime    改造后结束时间
   */
  retrofitCompared (measureId, beforeStartTime, beforeEndTime, afterStartTime, afterEndTime) {

    let params = {
      measureId, beforeStartTime, beforeEndTime, afterStartTime, afterEndTime
    }
    return axios.post(base.tmp.retrofitCompared, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 告警列表
   * @param {*} startTime   开始时间
   * @param {*} endTime    结束时间
   */
  getEventRecordGroupStatistics (startTime, endTime) {

    let params = {
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
    }
    return axios.post(base.tmp.getEventRecordGroupStatistics, utils.postParamsArrayToJsonString(params))
  },
  getPowerRunningState (measureId, startTime, endTime) {
    let params = {
      measureId: measureId, startTime: startTime.replace(/-/g, "/"), endTime: endTime.replace(/-/g, "/")
    }
    return axios.post(base.tmp.getPowerRunningState, utils.postParamsArrayToJsonString(params))

  },//查询用户信息
  getAllByType (measureId, type, startTime, endTime) {
    let params = {
      measureId: measureId, type: type, startTime: startTime.replace(/-/g, "/"), endTime: endTime.replace(/-/g, "/")
    }
    return axios.post(base.tmp.getAllByType, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 物业总览的接口
   * @returns 
   */
  getPropertyInformationOverview () {
    let params = {
    }
    // {
    //   // 物业公司名称
    //   "companyName",
    //   // 物业公司联系电话
    //   "contactNo",
    //   // 业主数目
    //   "proprietorNum",
    //   // 场地数目
    //   "rentalNum",
    //   // 出租率
    //   "rentPercent",
    //   // 上月缴费率
    //   "lastPaiedPercent",
    //   // 本月支出
    //   "cost",
    //   // 本月收入
    //   "income",
    //   // 本月利润
    //   "profit",
    //   // 本期应缴数量
    //   "shouldPayedNum",
    //   // 本期实缴数量
    //   "PayedNum",
    //   // 本期待缴数量
    //   "waitPayedNum",
    //   // 收入支出曲线
    // feeList
    //   [
    //     {
    //       // 时间
    //       "date"
    //       // 支出
    //       "cost"
    //       // 收入
    //       "income"
    //     },
    //   ]
    //   // 通信状态表格
    // missList
    //   [
    //     {
    //       // 业主公司Id
    //       "proprietorCompanyId",
    //       // 业主公司名称
    //       "proprietorName",
    //       // 场地id
    //       "rentId",
    //       // 场地名称
    //       "rentName",
    //       // 测量点id
    //       "measureId",
    //       // 测量点名称
    //       "measureName",
    //       // 测量点编号
    //       "pointNumber",
    //       // 租户id
    //       "lesseeId",
    //       // 租户名
    //       "lesseeName",
    //       // 最后一次通信时间
    //       "lastConnectTime"
    //     },...
    //   ]
    // }
    return axios.post(base.tmp.getPropertyInformationOverview, utils.postParamsArrayToJsonString(params))
  },
  /**
   * 公司用户概览
   * @param {*} startTime 
   * @param {*} endTime 
   * @returns 
   */
  companyUserProfile (startTime, endTime) {
    // 接口详情http://192.168.0.201/:8090/doc.html#/default/租户相关报表/companyUserProfileUsingPOST
    return axios.post(base.tmp.companyUserProfile, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },
  /**
   * 个人用户概览
   * @param {*} startTime 
   * @param {*} endTime 
   * @returns 
   */
  overviewOfIndividualUsers (startTime, endTime) {
    // 接口详情http://192.168.0.201/:8090/doc.html#/default/租户相关报表/overviewOfIndividualUsersUsingPOST
    return axios.post(base.tmp.overviewOfIndividualUsers, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },

  getProprietorInformationOverview () {
    // {
    //   // 业主公司
    //   companyName
    //   // 联系电话
    //   phoneNumber
    //   // 场地数量
    //   rentalNum
    //   // 托管场地数量
    //   trusteeshipRentalNum
    //   // 托管物业数量
    //   trusteeshipPropertyNum
    //   // 托管率
    //   trusteeshipRatio
    //   // 本月支出
    //   cost
    //   // 本月收入
    //   income
    //   // 本月利润
    //   profit
    //   // 本期应缴数量
    //   shouldPayedNum
    //   // 本期实缴数量
    //   payedNum
    //   // 本期代缴数量
    //   waitPayedNum
    //   // 收支曲线
    //   feeList:[
    //    {
    //     // 时间
    //     date
    //     // 支出
    //     cost
    //     // 收入
    //     income
    //    }
    //   ]
    //   // 在线状态
    //   missingList: [
    //    {
    //     同物业总览
    //    }
    //   ]
    //  }
    return axios.post(base.tmp.getProprietorInformationOverview, utils.postParamsArrayToJsonString({}))
  },
  //
  /**
 * 根据告警类型统计告警
 * @param {*} startTime 
 * @param {*} endTime 
 */
  getEventStatisticsNumByType (startTime, endTime) {
    let params = {
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime
    }
    console.log(base.tmp.getEventStatisticsNumByType)
    return axios.post(base.tmp.getEventStatisticsNumByType, utils.postParamsArrayToJsonString(params))
  },
  /**
* 根据告警类型统计告警
* @param {*} startTime
* @param {*} endTime
*/
  getEventStatisticsNumByCode (startTime, endTime, limit) {
    let params = {
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      limit: limit,
    };
    return axios.post(
      base.tmp.getEventStatisticsNumByCode,
      utils.postParamsArrayToJsonString(params)
    );
  },
  getElectricSaftyUseOverviewForProperty () {
    let params = {};
    // areaNumber  项目数量
    // companyId: "10523617751441480"
    // companyName: "俊凯物业公司（物业）"
    // contactTel: 联系电话
    // currentAlarmNumber: 今天告警数
    // dayTrendList: 日告警趋势
    // equipmentNumber: 监控设备数量
    // eventTypeDayList: 日告警类型占比
    // eventTypeMonthList: 月告警类型占比
    // eventTypeYearList: 年告警类型占比
    // handleNumber: 今日处理告警数
    // locationList: 业主坐标
    // monthAlarmNumber: 月告警数量
    // monthTrendList: 月告警趋势
    // onLineEquipNumber: 在线设备数量
    // onLineRate: 在线率
    // recordList: 告警记录
    // unHandleNumber:今日未处理告警数
    // yearTrendList: 年告警趋势
    return axios.post(
      base.tmp.getElectricSaftyUseOverviewForProperty,
      utils.postParamsArrayToJsonString(params)
    );
  },
  puzzleEventSummationInfo (startTime, endTime) {
    let params = {
      startTime, endTime
    };
    return axios.post(
      base.tmp.puzzleEventSummationInfo,
      utils.postParamsArrayToJsonString(params)
    );
  },
  puzzleEventSummationInfoInPeriod (type, startTime, endTime) {
    let params = {
      type, startTime, endTime
    };
    return axios.post(
      base.tmp.puzzleEventSummationInfoInPeriod,
      utils.postParamsArrayToJsonString(params)
    );
  },

  getGroupDataInfo3(measureIds, pointCode, pointNumber, isRang, time) {
    return axios.post(
      base.tmp.getGroupDataInfo3,
      utils.postParamsArrayToJsonString({
        measureIds,
        pointCode,
        pointNumber,
        isRang,
        time
      })
    );
  }
}

export default tmp;
